module.exports = __webpack_public_path__ + "static/media/SK.3f1f1962.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/SK.svg
// module id = 359
// module chunks = 0